













































































import { Component, Prop, Vue } from 'vue-property-decorator';
import KBMediaListItem from '@/models/KnowledgeBase/KBMediaListItem';
import KBMediaType from '@/models/KnowledgeBase/KBMediaType';

@Component({
  name: 'MediaCard'
})
export default class MediaCard extends Vue {
  @Prop({ required: true })
  public media!: KBMediaListItem;

  get thumbnailUrl(): string {
    return this.media.thumbnailUrl;
  }

  get mediaTypeColor(): string {
    switch (this.media.mediaType) {
      case KBMediaType.Image:
        return 'blue';
      case KBMediaType.Video:
        return 'purple';
      case KBMediaType.File:
        return 'green';
      default:
        return 'grey';
    }
  }

  get mediaTypeIcon(): string {
    switch (this.media.mediaType) {
      case KBMediaType.Image:
        return 'mdi-image';
      case KBMediaType.Video:
        return 'mdi-video';
      case KBMediaType.File:
        return 'mdi-file';
      default:
        return 'mdi-file';
    }
  }

  get mediaTypeText(): string {
    switch (this.media.mediaType) {
      case KBMediaType.Image:
        return 'Image';
      case KBMediaType.Video:
        return 'Video';
      case KBMediaType.File:
        return 'File';
      default:
        return 'Unknown';
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }
}
